import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "monitoring-tabs default-tabs" }
const _hoisted_2 = { class: "space-x-8 flex border-b border-black border-opacity-10" }
const _hoisted_3 = { class: "flex pr-4" }
const _hoisted_4 = { class: "flex pr-4" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverviewTab = _resolveComponent("OverviewTab")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_WaterTab = _resolveComponent("WaterTab")!
  const _component_FoodTab = _resolveComponent("FoodTab")!
  const _component_WeightTab = _resolveComponent("WeightTab")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Tabs, {
        teleport: "#monitoring-tabs-target",
        "active-tab-class": "--active",
        onRewrite: _ctx.onTabChange
      }, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Tab, {
                name: _ctx.$t('views.monitoring.tabTitles.overview'),
                default: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OverviewTab, {
                    items: _ctx.filteredItems,
                    loading: _ctx.isLoading
                  }, null, 8, ["items", "loading"])
                ]),
                _: 1
              }, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Tab, {
                name: _ctx.$t('views.monitoring.tabTitles.water')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_WaterTab, {
                    items: _ctx.filteredItems,
                    loading: _ctx.isLoading
                  }, null, 8, ["items", "loading"])
                ]),
                _: 1
              }, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Tab, {
                name: _ctx.$t('views.monitoring.tabTitles.food')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FoodTab, {
                    items: _ctx.filteredItems,
                    loading: _ctx.isLoading
                  }, null, 8, ["items", "loading"])
                ]),
                _: 1
              }, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Tab, {
                name: _ctx.$t('views.monitoring.tabTitles.weight')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_WeightTab, {
                    items: _ctx.filteredItems,
                    loading: _ctx.isLoading
                  }, null, 8, ["items", "loading"])
                ]),
                _: 1
              }, 8, ["name"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onRewrite"]),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        id: "monitoring-tabs-target",
        class: "mt-6"
      }, null, -1))
    ])
  ]))
}